import 'bootstrap-select'

document.addEventListener("turbolinks:load", function() {
  $(function () {
    $('#conversion_from_currency').selectpicker({ liveSearch: true });
  });
})
